import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FabButton } from 'src/app/nav/fab-menu/fab-menu.component';
import { AnalyticsResultsService, DailyBalanceStatistic } from 'src/app/shared/services/analytics-results.service';
import { BankAccount, BankAccountsService, BankTransaction } from 'src/app/shared/services/bank-accounts.service';

@Component({
  selector: 'app-bank-account-detail',
  templateUrl: './bank-account-detail.component.html',
  styleUrls: ['./bank-account-detail.component.scss']
})
export class BankAccountDetailComponent implements OnInit {
  accountLoading: boolean = true;
  transLoading: boolean = true;
  dailyBalanceLoading: boolean = true;
  account: BankAccount = new BankAccount();
  transactions: BankTransaction[] = new Array<BankTransaction>();
  dailyBalance: DailyBalanceStatistic[] = new Array<DailyBalanceStatistic>();
  accountId: string = "";
  isMobile: boolean = false;
  transactionsNotFound: boolean = false;
  dailyBalanceNotFound: boolean = false;
  balanceTrendToShow: string = "oneYear";
  transactionsDisplayColumns: string[] = ['icons', 'transDate', 'description_desktop', 'amt'];
  numberOfTransactions: number = 50;
  numberOfTransactionsOptions: number[] = [50, 100, 250];

  fabButtons: FabButton[] = [
    {
      icon: 'rule',
      label: 'Enrichment Rules',
      route: '/bank/accounts/enrichment/rulesets'
    }
  ];

  constructor(private bankAccSvc: BankAccountsService, private analyticsSvc: AnalyticsResultsService, private activatedRoute: ActivatedRoute, breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      if (result.matches) {
        /* handset layout (portait) */
        this.transactionsDisplayColumns = ['transShortDate', 'description_mobile', 'amt'];
        this.isMobile = true;
      } else {
        /* all other layouts */
        this.isMobile = false;
        if (this.account.AccountType && this.account.AccountType === "KIWISAVER") {
          this.transactionsDisplayColumns = ['transDate', 'description_desktop', 'amt'];
        } else {
          this.transactionsDisplayColumns = ['icons', 'transDate', 'description_desktop', 'amt'];
        }
      }
    });
  }

  ngOnInit(): void {
    this.accountId = this.activatedRoute.snapshot.params['accountId'];

    this.bankAccSvc.getBankAccount(this.accountId)
      .subscribe({
        next: (data: BankAccount) => {
          this.account = data;
          if (this.account.AccountType && this.account.AccountType === "KIWISAVER") {
            if(this.isMobile) {
              this.transactionsDisplayColumns = ['transShortDate', 'description_mobile', 'amt'];
            } else {
              this.transactionsDisplayColumns = ['transDate', 'description_desktop', 'amt'];

            }
          }
          this.accountLoading = false;
        }
      });

    this.loadTransactions();
    this.loadDailyBalance();

  }

  onNumberOfTransactionsChange() {
    this.loadTransactions();
  }

  onDailyBalanceGraphChange() {
    this.loadDailyBalance();
  }

  loadTransactions() {
    this.transLoading = true;
    this.bankAccSvc.getRecentTransactionsByAccount(this.accountId, this.numberOfTransactions)
      .subscribe({
        next: (data: BankTransaction[]) => {
          this.transactions = data;
          this.transLoading = false;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status == 404) {
            this.transactionsNotFound = true;
            this.transLoading = false;
          } else {
            throw err;
          }
        }
      });
  }

  loadDailyBalance() {
    this.dailyBalanceLoading = true;
    if(this.balanceTrendToShow === "oneYear") {
      this.analyticsSvc.getDailyBalanceByAccountLastYear(this.accountId)
      .subscribe({
        next: (data: DailyBalanceStatistic[]) => {
          this.dailyBalance = data;
          this.dailyBalanceLoading = false;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status >= 400 && err.status <= 404) {
            this.dailyBalanceNotFound = true;
            this.dailyBalanceLoading = false;
          } else {
            throw err;
          }
        }
      });
    } else {
    this.analyticsSvc.getDailyBalanceByAccountYearToDate(this.accountId)
      .subscribe({
        next: (data: DailyBalanceStatistic[]) => {
          this.dailyBalance = data;
          this.dailyBalanceLoading = false;
        },
        error: (err: HttpErrorResponse) => {
          if (err.status >= 400 && err.status <= 404) {
            this.dailyBalanceNotFound = true;
            this.dailyBalanceLoading = false;
          } else {
            throw err;
          }
        }
      });
    }
  }

  getIncomeText(txn: BankTransaction): string {
    return this.bankAccSvc.getIncomeTypeText(txn.IncomeType) + " from " + txn.IncomeSource;
  }

  getTransactionTypeIcon(type: string): string {
    switch (type) {
      case 'CREDIT CARD':
        return "credit_card"

      case 'ATM':
        return "local_atm"
  
      case 'STANDING ORDER':
        return "schedule"

      case 'PAYMENT':
        return "payments"

      case 'EFTPOS':
        return "credit_card"

      case 'TRANSFER':
        return "sync_alt";

      case 'TAX':
        return "gavel";

      case 'LOAN':
        return "account_balance"
      default:
        break;
    }

    return "";
  }

  get AccountType(): string {
    if (!this.account || !this.account.AccountType) {
      return "Account";
    }

    switch (this.account.AccountType) {
      case 'CREDITCARD':
        return "Credit Card";

      case 'KIWISAVER':
        return "Kiwi Saver";

      default:
        return "Account";
    }
  }
}
